module.exports = __webpack_public_path__ + "assets/img/shiyong.25374415.png";